import { Box, NumberBadge } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

export interface Step {
  number: number
  content: string | JSX.Element
}

interface Props {
  steps: Step[]
}

function HelpSteps({ steps }: Props): JSX.Element {
  return (
    <Box flexDirection="column" gap="s24" paddingBottom="s12">
      {steps.map((step) => (
        <Box key={step.number} flexDirection="row" gap="s12">
          <Box minWidth="s24">
            <NumberBadge label={step.number} />
          </Box>
          <Box flexDirection="column">{step.content}</Box>
        </Box>
      ))}
    </Box>
  )
}

export default observer(HelpSteps)
